import {
  Input,
  Checkbox,
  booleanOptions,
  MultiSearchForm,
  useDebouncedSearch,
} from "@";
import { searchValues } from "../utils/options";

const MultiSearch = ({ onSubmit, search, updateSearch }) => {
  const handleInputChange = (field, value) => {
    updateSearch({
      values: { ...search.values, [field]: value },
    });
  };

  useDebouncedSearch(onSubmit, search.values, searchValues);

  return (
    <>
      <MultiSearchForm
        show={search.show}
        onSubmit={onSubmit}
        className="multi-search-form xl:grid-cols-7"
        reset={() => updateSearch({ values: searchValues })}
      >
        {/* Input for searching by searchKey */}
        <Input
          star
          label="كلمة البحث"
          value={search.values.searchKey}
          change={(e) => handleInputChange("searchKey", e.target.value)}
        />

        {/* Input for searching by message status */}
        <Input
          star
          type="select"
          label="تم الارسال"
          list={booleanOptions}
          value={search.values.isMessageSent}
          change={(e) => handleInputChange("isMessageSent", e.target.value)}
        />

        {/* Input for searching by date */}
        <Input
          star
          showTimeSelect
          type="date-range"
          labelA="من تاريخ"
          labelB="الي تاريخ"
          style="lg:col-span-2"
          valueB={search.values.toDate}
          valueA={search.values.fromDate}
          changeA={(e) => handleInputChange("fromDate", e)}
          changeB={(e) => handleInputChange("toDate", e)}
        />

        {/* Input for searching action */}
        <div>
          <label className="input-label">الحدث</label>
          <button
            id="messagesActions"
            data-dropdown-toggle="messagesActionsCheckbox"
            className="input flex h-[42px] items-center justify-end"
            type="button"
          >
            <svg
              className="ms-3 h-2.5 w-2.5 stroke-gray-500 dark:stroke-gray-400"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 4 4 4-4"
              />
            </svg>
          </button>

          <div
            id="messagesActionsCheckbox"
            className="card z-10 hidden w-fit p-3"
          >
            <ul aria-labelledby="messagesActions" className="space-y-3">
              <li>
                <Checkbox
                  label="اكمال الشراء"
                  value={search.values.hasOrderCompleted}
                  change={(e) =>
                    handleInputChange("hasOrderCompleted", e.target.checked)
                  }
                />
              </li>
              <li>
                <Checkbox
                  label="نسخ الحساب البنكي"
                  value={search.values.hasIbanCopied}
                  change={(e) =>
                    handleInputChange("hasIbanCopied", e.target.checked)
                  }
                />
              </li>
              <li>
                <Checkbox
                  label="النقر على الرابط"
                  value={search.values.hasLinkClicked}
                  change={(e) =>
                    handleInputChange("hasLinkClicked", e.target.checked)
                  }
                />
              </li>
            </ul>
          </div>
        </div>
      </MultiSearchForm>
    </>
  );
};

export default MultiSearch;
